export const getCropReportsList = state => state?.cropReports?.reportsList;
export const getIsReportsListFetching = state => state?.cropReports?.isReportsListFetching;

export const getCropReport = state => state?.cropReports?.report;
export const getIsCropReportFetching = state => state?.cropReports?.isCropReportFetching;

export const getReportsSettings = state => state?.cropReports?.reportsSettings;
export const getIsReportsSettingsFetching = state => state?.cropReports?.isReportsSettingsFetching;
